import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { MaskLines } from "@/components/motion";

export const PageHero = ({ eyebrow, lines, intro, image, imageAlt, corner = "bl", accent = "var(--blue)", children }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["0%", "14%"]);
  return (
    <section ref={ref} className="relative pt-32 sm:pt-40 pb-16 sm:pb-24 overflow-hidden" data-testid="page-hero">
      <div className="wrap grid gap-12 lg:grid-cols-12 items-end">
        <div className={image ? "lg:col-span-7" : "lg:col-span-10"}>
          <motion.span className="eyebrow" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.8 }}>{eyebrow}</motion.span>
          <MaskLines lines={lines} testId="page-title" className="mt-6 text-5xl sm:text-6xl lg:text-8xl leading-[0.98] tracking-tight" lastClassName={lines.length > 1 ? "italic text-[var(--green-deep)]" : ""} />
          {intro && (
            <motion.p initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.5, duration: 0.9 }} className="mt-8 max-w-2xl text-base sm:text-lg leading-relaxed text-[var(--ink-soft)]" data-testid="page-intro">
              {intro}
            </motion.p>
          )}
          {children}
        </div>
        {image && (
          <div className="lg:col-span-5 relative">
            <div aria-hidden="true" className="absolute -left-6 -bottom-6 w-28 h-28 petal-tr" style={{ background: accent }} />
            <motion.div initial={{ clipPath: "inset(100% 0 0 0)" }} animate={{ clipPath: "inset(0% 0 0 0)" }} transition={{ duration: 1.2, ease: [0.7, 0, 0.2, 1], delay: 0.2 }} className={`relative aspect-square overflow-hidden petal-${corner} bg-[var(--green-pale)]`}>
              <motion.img style={{ y, scale: 1.15 }} src={image} alt={imageAlt} className="photo absolute inset-0 w-full h-full object-cover" />
            </motion.div>
          </div>
        )}
      </div>
    </section>
  );
};
